import './imports/modernizr.min.js';
import ScrollReveal from './imports/scrollreveal.min.js';
import './imports/twentytwenty/jquery.event.move.js';
import './imports/twentytwenty/jquery.twentytwenty.js';

import './imports/cookiebar.js';

(function ($) {

	var ww, wh;
	var mw;
	var projectw, projecth;
	var sc_y;
	var supports_transforms = true;

	$(window).load(function () {

		$(".product-before-after .text").twentytwenty();
		$("#product-nav-box").append('<div class="close"></div>');

		$("#product-nav-box .close").click(function () {
			$("#product-nav-box").toggleClass("closed");
		});

	});



	$(window).scroll(function () {
		var productBox = $("#product-nav-box");
		var scrollTop = $(window).scrollTop();
		var windowHeight = $(window).height();

		if (scrollTop > windowHeight * 0.3) {
			productBox.addClass("active");
		} else {
			productBox.removeClass("active");
		}

	});





	$(window).resize(function () {
		ww = $(window).width();
		wh = $(window).height();
		if (ww <= 960) {
			mw = 0;
		} else if (ww <= 1040) {
			mw = 260;
		} else {
			mw = 320;
		}
		projectw = (ww - mw) * 0.9;
		projecth = wh * 0.85;
		$("body.projects .mod_article .elements > .inside > .block").width(projectw);

		// Jump to nearest project slide
		$("body.projects .mod_article .elements > .inside").each(function () {
			if (supports_transforms == false) {
				var posx = $(this).position().left;
			} else {
				var posx = getTransformX($(this));
			}
			var roundto = 1 / projectw;
			var newposx = Math.round(posx * roundto) / roundto;
			if (supports_transforms == false) {
				$(this).css("left", newposx);
			} else {
				$(this).css({
					"transform": "translate3d(" + newposx + ", 0, 0)",
					"-webkit-transform": "translate3d(" + newposx + ", 0, 0)"
				});
			}
		});


		// Open / close project texts
		if (ww < 1040) {
			$("body.projects .mod_article .elements .inside .block .text").removeClass("open");
		} else {
			$("body.projects .mod_article .elements .inside .block .text").addClass("open");
		}

		if (window.innerWidth <= 960) {
			if (typeof $('.background_image_media').attr('style') === 'undefined') {
				$('.background_image_media').each(function () {
					var _self = $(this);
					var _style = _self.data('style');

					_self.attr('style', _style);
				});
			}
		}

		if (window.innerWidth > 960) {
			if (typeof $('.background_image').attr('style') === 'undefined') {
				$('.background_image').each(function () {
					var _self = $(this);
					var _style = _self.data('style');

					_self.attr('style', _style);
				});
			}
		}
	});

	$(window).on("scroll touchmove", function () {
		sc_y = $(window).scrollTop();
	});





	// Project slider

	function showProjectSlide(projectid, slidenum) {

		var el_slider = $("#" + projectid + " .elements > .inside");
		var num_slides = el_slider.find("> .block").length;

		var el_left = $("#" + projectid + " .controls .prev");
		var el_right = $("#" + projectid + " .controls .next");
		var el_texts = $("#" + projectid + " .text");

		if ($("body").hasClass("ar")) {
			var el_text = $("#" + projectid + " .elements > .inside > .block:eq(" + (-slidenum) + ") .text");
		} else {
			var el_text = $("#" + projectid + " .elements > .inside > .block:eq(" + slidenum + ") .text");
		}

		el_left.css({ "opacity": 0, "pointer-events": "none" });
		el_right.css({ "opacity": 0, "pointer-events": "none" });
		el_texts.css({ "opacity": 0 });

		setTimeout(function () {
			if (supports_transforms == false) {
				el_slider.animate({ left: (- slidenum * projectw) });
			} else {
				el_slider.css({
					"transform": "translate3d(" + (- slidenum * projectw) + "px, 0, 0)",
					"-webkit-transform": "translate3d(" + (- slidenum * projectw) + "px, 0, 0)"
				});
			}


			setTimeout(function () {

				if (!$("body").hasClass("ar")) {
					if(slidenum !== 0) {
						el_left.css({ "opacity": 1, "pointer-events": "auto" });
					}
					if(slidenum !== num_slides - 1) {
						el_right.css({ "opacity": 1, "pointer-events": "auto" });
					}
				} else {
					if (slidenum !== -num_slides + 1) {
						el_left.css({ "opacity": 1, "pointer-events": "auto" });
					}
					if (slidenum !== 0) {
						el_right.css({ "opacity": 1, "pointer-events": "auto" });
					}
				}

				setTimeout(function () {
					el_text.css({ "opacity": 1 });
				}, 1500);
			}, 550);
		}, 350);

	}


	// Produkt Slider

	function showProductSlide(slidenum) {
		var el_slider = $(".mod_article.slider .inside");
		var num_slides = el_slider.find("> .block").length;

		var el_left = $(".mod_article.slider .prev");
		var el_right = $(".mod_article.slider .next");

		var slidew = parseInt(el_slider.find(".block").css("width"));
		var slidemargin = parseInt(el_slider.find(".block").css("margin-right"));
		var sliderw = $(".mod_article.slider").width();

		var slidesvisible = Math.floor((sliderw + slidemargin + 3) / (slidew + slidemargin));

		// Last slide?
		if ((slidenum == num_slides - slidesvisible) && slidenum != 0) {
			var gap = $(".mod_article.slider").width() - slidesvisible * (slidew + slidemargin);

			if (!$("body").hasClass("ar")) {
				el_slider.css({ left: (- slidenum * (slidew + slidemargin) + gap) });
			} else {
				el_slider.css({ right: (- slidenum * (slidew + slidemargin) + gap) });
			}
		} else {
			if (!$("body").hasClass("ar")) {
				el_slider.css({ left: (- slidenum * (slidew + slidemargin)) });
			} else {
				el_slider.css({ right: (- slidenum * (slidew + slidemargin)) });
			}
		}

		setTimeout(function () {

			if (!$("body").hasClass("ar")) {
				if (slidenum !== 0) {
					el_left.css({ "opacity": 1, "pointer-events": "auto" });
				} else {
					el_left.css({ "opacity": 0, "pointer-events": "none" });
				}

				if (slidenum !== num_slides - slidesvisible && (num_slides > slidesvisible)) {
					el_right.css({ "opacity": 1, "pointer-events": "auto" });
				} else {
					el_right.css({ "opacity": 0, "pointer-events": "none" });
				}
			} else {
				if (slidenum !== num_slides - slidesvisible && (num_slides > slidesvisible)) {
					el_left.css({ "opacity": 1, "pointer-events": "auto" });
				} else {
					el_left.css({ "opacity": 0, "pointer-events": "none" });
				}
				if (slidenum !== 0) {
					el_right.css({ "opacity": 1, "pointer-events": "auto" });
				} else {
					el_right.css({ "opacity": 0, "pointer-events": "none" });
				}
			}

		}, 350);

	}


	function checkBrowser() {
		if ($("body").is(".ie5, .ie6, .ie7, .ie8")) {
			if ($("body").is(".lang-de")) {
				$("#main").prepend("<div id='oldbrowser'>Sie nutzen einen veralteten Browser, der von dieser Website nicht mehr komplett unterstützt wird. Bitte updaten Sie auf eine aktuelle Version, auch zu Ihrer eigenen Sicherheit.</div>");
			} else {
				$("#main").prepend("<div id='oldbrowser'>You are using an outdated browser this website does not fully support. Please update it to enhance your experience and safety online.</div>");
			}
		}
	}


	$(document).ready(function () {


		$(".product-cards .card .image_container").each(function () {
			var link = $(this).parents(".card").find("a").attr("href");

			$(this).wrap('<a href="' + link + '"></a>');
			$(this).find("a").removeAttr("href");
		});


		if ($("html").hasClass("no-csstransforms3d") || $("html").hasClass("no-csstransitions")) {
			supports_transforms = false;
		}



		$(".product-gallery ul").slick({
			slide: "li",
			dots: false,
			infinite: true,
			speed: 300,
			//variableWidth: true,
			autoPlay: true
		});


		$("[data-lightbox]").each(function () {

			$(this).attr("data-fancybox", $(this).attr("data-lightbox"));

		});

		$("[data-fancybox]").fancybox({
			speed: 500,
			slideShow: false,
			fullScreen: false,
			thumbs: false,
			transitionEffect: "slide",
			lang: 'de',
			infobar: true,

			clickContent: function (current, event) {
				return current.type === 'image' ? 'next' : false;
			},

			beforeShow: function () {
				this.title = this.title + " - " + $(this.element).data("caption");
			}
		});



		scrollAnimations();



		$("#scroll-down").click(function (event) {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: ($(".mod_article:eq(2)").not(".first").first().offset().top)
			}, 500);
		});



		$(window).resize();
		$(window).scroll();
		draw();


		checkBrowser();



		$("body.projects .mod_article .controls .next, body.projects .mod_article .controls .prev").click(function () {
			var el_article = $(this).closest(".mod_article");
			if (supports_transforms == false) {
				var current_slide = Math.round(- el_article.find(".elements > .inside").position().left / projectw);
			} else {
				var current_slide = Math.round(- getTransformX(el_article.find(".elements > .inside")) / projectw);
			}

			var num_slides = el_article.find(".elements > .inside > .block").length;
			var direction = $(this).is(".next") ? 'next' : 'prev';

			if (!$("body").hasClass("ar")) {
				if (direction === 'next' && current_slide !== num_slides - 1) {
					showProjectSlide(el_article.attr("id"), current_slide + 1);
				}

				if (direction === 'prev' && current_slide !== 0) {
					showProjectSlide(el_article.attr("id"), current_slide - 1);
				}
			} else {
				if (direction === 'next' && current_slide !== 0) {
					showProjectSlide(el_article.attr("id"), current_slide + 1);
				}

				if (direction === 'prev' && current_slide !== num_slides - 1) {
					showProjectSlide(el_article.attr("id"), current_slide - 1);
				}
			}
		});


		// Hamburger Menu Toggle

		$("#menutoggle").click(function () {
			$("#left, #right").toggleClass("open");
		});

		// News aufklappen

		$(".mod_newslist .more a").click(function (e) {
			e.preventDefault();
			//$(".mod_newslist .ce_text").slideUp(400);
			$(this).closest('.layout_full').find('.text').toggleClass("open");
			$(this).hide();
		});

		// Produkte Übersicht

		$("body.produkte, body.qualitaet").find(".mod_article .ce_text").mouseover(function (e) {
			$(".mod_article .ce_text").not(this).addClass("inactive");
		}).mouseleave(function () {
			$(".mod_article .ce_text").removeClass("inactive");
		});

		// Gallery Slider

		$(".mod_article.slider").append('<div class="prev"></div><div class="next"></div>');

		$(".mod_article.slider .next, .mod_article.slider .prev").click(function () {
			var el_article = $(this).closest(".mod_article");
			var slidew = parseInt(el_article.find(".block").css("width"));
			var slidemargin = parseInt(el_article.find(".block").css("margin-right"));

			if (!$("body").hasClass("ar")) {
				var current_slide = Math.round(- (parseInt(el_article.find(".elements > .inside").css("left")) / (slidew + slidemargin)));
			} else {
				var current_slide = Math.round((parseInt(el_article.find(".elements > .inside").css("right")) / (slidew + slidemargin)));
				current_slide = (current_slide != 0 ? (-current_slide) : 0);
			}

			var num_slides = el_article.find(".elements > .inside > .block").length;
			var sliderw = $(".mod_article.slider").width();

			var slidesvisible = Math.floor((sliderw + slidemargin + 3) / (slidew + slidemargin));

			if (!$("body").hasClass("ar")) {
				if ($(this).is(".next") && current_slide !== num_slides - slidesvisible) {
					showProductSlide(current_slide + 1);
				}
				if ($(this).is(".prev") && current_slide !== 0) {
					showProductSlide(current_slide - 1);
				}
			} else {
				if ($(this).is(".next") && current_slide !== 0) {
					showProductSlide(current_slide - 1);
				}

				if ($(this).is(".prev") && current_slide !== num_slides - 1) {
					showProductSlide(current_slide + 1);
				}
			}






		});
		if ($(".mod_article.slider").length > 0) {
			showProductSlide(0);
		}


		// Mobile: toggle project texts

		$("body.projects .mod_article .elements .text").click(function () {
			$(this).toggleClass("open");
			$(this).closest(".mod_article").find(".controls").toggleClass("textopen");
		});


	});



	function draw() {



		// FADE INACTIVE PROJECTS

		if (ww > 960) {

			$("body.projects .mod_article").each(function (i, e) {
				var dist = (projecth * i) - sc_y; // Abstand Oberkante Projekt zur oberen Browserkante
				var dist_bottom = dist + projecth; // // Abstand Unterkante Projekt zur oberen Browserkante


				if (dist < wh && dist > 0) {

					// Unten ausblenden
					var rel = (dist - wh / 2) / (wh - wh / 2);
					$(this).css("opacity", (1 - rel));

				} else if (dist_bottom < (wh / 2) && dist_bottom > 0) {

					// Oben ausblenden
					var rel = (dist_bottom - wh / 2) / (wh - wh / 2);
					$(this).css("opacity", (1 + rel));

				} else {

					$(this).css("opacity", 1);

				}
			});

		} else {
			$("body.projects .mod_article").css("opacity", 1);
		}

		requestAnimationFrame(draw);

	}





	function scrollAnimations() {
		// Scroll animation
		window.sr = ScrollReveal();


		$(".product-thumb img").each(function () {
			var thisSection = $(this).parents(".mod_article");


			sr.reveal($(this), {
				duration: 750,
				delay: 500,
				origin: "bottom",
				scale: 0.9,
				distance: "150px",
				easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
				reset: false,
				afterReveal: function (domEl) {
					thisSection.addClass("start-animation");
				},
			});

		});


		$(".product-text-image img").each(function () {
			var thisSection = $(this).parents(".mod_article");


			sr.reveal($(this), {
				duration: 1000,
				delay: 500,
				origin: "bottom",
				scale: 0.9,
				distance: "150px",
				easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
				reset: false,
				afterReveal: function (domEl) {
					thisSection.addClass("start-animation");
				},
			});

		});


		$("#made-in-germany").each(function () {
			var thisSection = $(this).parents(".mod_article");


			sr.reveal($(this), {
				duration: 1750,
				origin: "bottom",
				scale: 0.9,
				distance: "150px",
				easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
				reset: false,
				afterReveal: function (domEl) {
					thisSection.addClass("start-animation");
				},
			});

		});


		$(".product-bubble").each(function () {
			var thisSection = $(this).parents(".mod_article");


			sr.reveal($(this), {
				duration: 1000,
				delay: 1500,
				origin: "bottom",
				scale: 0.5,
				distance: "50px",
				easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
				reset: false,
				afterReveal: function (domEl) {
					thisSection.addClass("start-animation");
				},
			});

		});


		$(".detail img").each(function () {
			var thisSection = $(this).parents(".mod_article");

			sr.reveal($(this), {
				delay: 500,
				duration: 1500,
				origin: "bottom",
				scale: 1.5,
				distance: "0",
				easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
				reset: false,
				opacity: 1,
				afterReveal: function (domEl) {
					thisSection.addClass("start-animation");
				},
			});

		});


		$(".product-cards .card").each(function () {
			var thisSection = $(this).parents(".mod_article");

			sr.reveal($(this), {
				delay: 250,
				duration: 750,
				origin: "bottom",
				scale: 0.9,
				distance: "0",
				easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
				reset: false,
				opacity: 0.5,
				afterReveal: function (domEl) {
					thisSection.addClass("start-animation");
				},
			});

		});
	}


})(jQuery);




// ANALYTICS OPT OUT
var gaProperty = 'UA-43769535-10';
var disableStr = 'ga-disable-' + gaProperty;
if (document.cookie.indexOf(disableStr + '=true') > -1) {
	window[disableStr] = true;
}
function gaOptout() {
	document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
	window[disableStr] = true;
	alert("Opt-out erfolgreich");
}






// HELPERS

function matrixToArray(str) {
	return str.match(/(-?[0-9\.]+)/g);
}

function getTransformX(el) {
	var a_index;
	//console.log(el.css("transform").substr(0,8));
	//console.log(matrixToArray(el.css("transform")));
	if (el.css("transform").substr(0, 8) == "matrix3d") {
		a_index = 13;
	} else {
		a_index = 4;
	}

	//console.log(a_index);
	//console.log(matrixToArray(el.css("transform"))[a_index]);
	return parseInt(matrixToArray(el.css("transform"))[a_index]);
}



// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller
// fixes from Paul Irish and Tino Zijdel

(function () {
	var lastTime = 0;
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
			|| window[vendors[x] + 'CancelRequestAnimationFrame'];
	}

	if (!window.requestAnimationFrame)
		window.requestAnimationFrame = function (callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function () { callback(currTime + timeToCall); },
				timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};

	if (!window.cancelAnimationFrame)
		window.cancelAnimationFrame = function (id) {
			clearTimeout(id);
		};
}());